// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/wizard_step_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/wizard_step_response.proto.
 */
export const file_responses_v1_wizard_step_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvd2l6YXJkX3N0ZXBfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSKbAQoSV2l6YXJkU3RlcFJlc3BvbnNlEk8KDHdpemFyZF9zdGVwcxgBIAMoCzIrLnJlc3BvbnNlcy52MS5XaXphcmRTdGVwUmVzcG9uc2UuV2l6YXJkU3RlcFIMd2l6YXJkX3N0ZXBzGjQKCldpemFyZFN0ZXASCgoCaWQYASABKA0SDAoEbmFtZRgCIAEoCRIMCgRkb25lGAMgASgIQoIBChBjb20ucmVzcG9uc2VzLnYxQhdXaXphcmRTdGVwUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message responses.v1.WizardStepResponse
 */
export type WizardStepResponse = Message<'responses.v1.WizardStepResponse'> & {
    /**
     * @generated from field: repeated responses.v1.WizardStepResponse.WizardStep wizard_steps = 1 [json_name = "wizard_steps"];
     */
    wizardSteps: WizardStepResponse_WizardStep[];
};

/**
 * Describes the message responses.v1.WizardStepResponse.
 * Use `create(WizardStepResponseSchema)` to create a new message.
 */
export const WizardStepResponseSchema: GenMessage<WizardStepResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_wizard_step_response, 0);

/**
 * @generated from message responses.v1.WizardStepResponse.WizardStep
 */
export type WizardStepResponse_WizardStep = Message<'responses.v1.WizardStepResponse.WizardStep'> & {
    /**
     * @generated from field: uint32 id = 1;
     */
    id: number;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: bool done = 3;
     */
    done: boolean;
};

/**
 * Describes the message responses.v1.WizardStepResponse.WizardStep.
 * Use `create(WizardStepResponse_WizardStepSchema)` to create a new message.
 */
export const WizardStepResponse_WizardStepSchema: GenMessage<WizardStepResponse_WizardStep> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_wizard_step_response, 0, 0);
